import PropTypes from 'prop-types';
import React from 'react';

import { treeAdapterPropTypes, treePluginPropTypes } from '../propTypes';
import TreeBody from '../TreeBody/TreeBody';
import TreeContent from './TreeContent';

const Tree = ({
  children,
  tree,
  adapter,
  plugins,
  models,
  filter,
  selection,
  context,
  onSelectionChange,
  handleClear,
  hasBottomPadding,
  isScrollDisabled,
}) => (
  <TreeContent
    adapter={adapter}
    context={context}
    filter={filter}
    handleClear={handleClear}
    hasBottomPadding={hasBottomPadding}
    isScrollDisabled={isScrollDisabled}
    models={models}
    plugins={plugins}
    selection={selection}
    tree={tree}
    onSelectionChange={onSelectionChange}
  >
    {children}
  </TreeContent>
);

Tree.Body = TreeBody;

Tree.propTypes = {
  tree: PropTypes.string.isRequired,
  adapter: treeAdapterPropTypes.isRequired,
  plugins: PropTypes.arrayOf(treePluginPropTypes).isRequired,
  context: PropTypes.any,
  children: PropTypes.node,
  models: PropTypes.arrayOf(PropTypes.any),
  filter: PropTypes.any,
  selection: PropTypes.oneOfType([
    PropTypes.any,
    PropTypes.arrayOf(PropTypes.any),
  ]),
  onSelectionChange: PropTypes.func,
  hasBottomPadding: PropTypes.bool,
  isScrollDisabled: PropTypes.bool,
};

Tree.defaultProps = {
  children: null,
  models: null,
  filter: null,
  context: null,
  selection: null,
  onSelectionChange: null,
  hasBottomPadding: true,
  isScrollDisabled: false,
};

export default Tree;
